import React from 'react';

const BaggageIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-baggage" />
    </div>
  );
};

export default BaggageIcon;
